import { render, staticRenderFns } from "./CertificationManage.vue?vue&type=template&id=123d0429&scoped=true"
import script from "./CertificationManage.vue?vue&type=script&lang=js"
export * from "./CertificationManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d0429",
  null
  
)

export default component.exports